import { EntityTypes } from 'constants/entities';
import { IHistoryItem, IRegisterReducer } from 'core/slices/register';
import { createSelector } from 'reselect';
import { RootState } from '../../../types';

const register = (state: RootState) => state.register;
const courseProgressId = (state: RootState) => state.state[EntityTypes.COURSE_PROGRESS];

export const selectHistory = createSelector([register, courseProgressId], parseHistory);

export function parseHistory(register: IRegisterReducer, courseProgressId: number) {
  const filter = (item: IHistoryItem) => item.courseProgressId === courseProgressId;
  return register.history.filter(filter);
}
